/* Import External Modules */
import { ns } from '@leverege/i18n';
import React from 'react';
/* Import Leverege Modules */
import { Checkbox, Flex, Label, NumericInput, PropertyGrid, Radio, Text } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';

/* Import Local Modules */
import UnitFormatter from "./PercentFormatter.js";
import Model from "./PercentFormatterModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.PercentFormatterEditor');

/* Initialize Constants */
const PREVIEW_VALUE = 0.85476;
/**
 * Editor for percent formatter.
 * @param {Object} props.value - Value formatter object.
 * @param {String} props.value.type - Value type, e.g. attr.formatter.percent.
 */
export default function PercentFormatterEditor(props) {
  // Get parameters
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);

  // Validate parameters
  if (value == null) {
    return null;
  }

  // Get format preview
  let preview = t('notAvailable');
  try {
    const rawPreview = UnitFormatter.format(PREVIEW_VALUE, value);
    preview = rawPreview.length > 0 ? rawPreview[0] : preview;
  } catch (error) {
    preview = t('invalidFormat');
  }
  // Render editor
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    style: {
      backgroundColor: 'var(--color-white)',
      border: 0
    },
    children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('dataFormat'),
      children: /*#__PURE__*/_jsxs(Flex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(Radio, {
          label: t('percentage'),
          on: false,
          eventData: "setFractional",
          value: Model.getFractional(value),
          onChange: evt => onModelChange({
            ...evt,
            value: false
          })
        }), /*#__PURE__*/_jsx(Radio, {
          label: t('fractional'),
          on: true,
          eventData: "setFractional",
          value: Model.getFractional(value),
          onChange: evt => onModelChange({
            ...evt,
            value: true
          })
        })]
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      stretch: true,
      label: t('maxDecimals'),
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        align: "center",
        children: [/*#__PURE__*/_jsx(NumericInput, {
          min: 0,
          max: 16,
          size: 4,
          allowError: false,
          eventData: "setMaxDecimals",
          hint: t('maxDecimalsHint'),
          value: Model.getMaxDecimals(value),
          onChange: onModelChange
        }), /*#__PURE__*/_jsx(Checkbox, {
          value: Model.getFixed(value),
          onChange: onModelChange,
          eventData: "setFixed"
        }), /*#__PURE__*/_jsx(Label, {
          variant: "input",
          style: {
            width: 105
          },
          children: t('padWithZeros')
        })]
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      fill: true,
      label: t('preview'),
      children: /*#__PURE__*/_jsx(Text, {
        children: `${preview}%`
      })
    })]
  });
}